module.exports = __webpack_public_path__ + "img/piping_width.0903f68e.png";